import React, { useEffect, useState } from "react";
import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";

import { saveAs } from "file-saver";

import {
  ManageCustomer,
  showMessage,
  getToken,
  random_rgba,
  trimFirstAndLastWhiteSpace,
  // is_superuser
} from "../../Functionalities/Functions";
import axios from "axios";
import FilterComponent from "../../CoreComponents/FilterComponent";
import FilterModalComponent from "../../CoreComponents/FilterModalComponent";
import { is_superuser, protocol } from "../../Functionalities/Config";
import LoadingComponent from "../../CoreComponents/LoadingComponent";
import NoDataComponent from "../../CoreComponents/NoDataComponent";

// function Body({ bo, na, nu, ar, ob, ao }) {
function Body() {
  const [data, setData] = useState({ id: "", name: "", data: [] });
  const [next, setNext] = useState("");
  const [prev, setPrev] = useState("");
  const [loading, setLoading] = useState(true);
  const [filter, setfilter] = useState({
    search_text: "",
    is_approved: "",
    is_blocked: "",
    is_deliveryboy: "",
    is_branch_admin: "",
    is_manager: "",
    is_customer: "true",
  });
  const [IsFilterApplied, setIsFilterApplied] = useState(false);

  useEffect(() => {
    getData();
  }, []);

  // useEffect(() => {
  //   {
  //     IsFilterApplied &&
  //     getData();
  //     setIsFilterApplied(false)
  //   }
  // }, [IsFilterApplied]);

  // useEffect(() => {
  //   if (localStorage.getItem('customer_filter')) {
  //     setfilter(JSON.parse(localStorage.getItem('customer_filter')))
  //     setIsFilterApplied(true)
  //   } else {
  //     setfilter({
  //       ...filter, search_text: "",
  //       is_approved: "",
  //       is_blocked: "",
  //       is_deliveryboy: "",
  //       is_branch_admin: "",
  //       is_manager: "",
  //       is_customer: "true",
  //     })
  //     getData()
  //   }
  // }, [])

  let params =
    // "only_customer="+(is_superuser)?0:1+"&keyword=all_profile" +
    "for_admin_panel_listing=true" +
    "&keyword=all_profile" +
    "&is_approved=" +
    filter.is_approved +
    "&is_blocked=" +
    filter.is_blocked +
    "&search_text=" +
    trimFirstAndLastWhiteSpace(filter.search_text) +
    // "&is_deliveryboy=" +
    // filter.is_deliveryboy +
    "&is_branch_admin=" +
    filter.is_branch_admin +
    "&is_manager=" +
    filter.is_manager +
    "&is_deliveryboy=" +
    filter.is_deliveryboy +
    "&only_customer=" +
    filter.is_customer; // +
  // "&limit=1000";
  // void 0

  // void 0

  // if (!is_superuser) {
  //   params = params + "&only_customer=true"
  // }

  const getData = () => {
    // showMessage("Loading customers", "info", "Loading", "bottom", "bottom-left", 0);

    let result = ManageCustomer("", "", "get", params);

    result
      .then((result) => {

        // add limit and value to the params on top to make this api work
        // const csvData = result.data.results.map((item) => {
        //   return {
        //     ID: item.id,
        //     Name: item.first_name,
        //     mobile: item.details.mobile,
        //     email: item.email,
        //   };
        // });

        // const csvFields = Object.keys(csvData[0]);
        // const csvRows = csvData.map((item) => Object.values(item));
        // const csvContent =
        //   csvFields.join(",") +
        //   "\n" +
        //   csvRows.map((row) => row.join(",")).join("\n");

        // const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8" });
        // saveAs(blob, "customers.csv");

        // commented after live collapse compare live diff from April 5 2025 and the very next for original
        // save as json:
        // Create JSON data from the result
        // const jsonData = result.data.results.map((item) => {
        //   return {
        //     id: item.id,
        //     name: item.first_name,
        //     mobile: item.details.mobile,
        //     email: item.email,
        //   };
        // });

        // commented after live collapse
        // Convert JSON data to a string and download as a JSON file
        // const jsonContent = JSON.stringify(jsonData, null, 2); // `null, 2` formats the JSON with indentation
        // const blob = new Blob([jsonContent], {
        //   type: "application/json;charset=utf-8",
        // });

        // commented after live collapse
        // Automatically download the JSON file
        // const fileName = "customers.json";
        // const link = document.createElement("a");
        // link.href = URL.createObjectURL(blob);
        // link.download = fileName;
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);

        // localStorage.setItem("jsonData", JSON.stringify(jsonData));

        setData({
          ...data,
          data: result.data.results,
        });
        setLoading(false);
        setNext(result.data.next);
        setPrev(result.data.previous);
      })
      .catch((err) => {
        showMessage(
          "Loading failed",
          "danger",
          "Loading error",
          "top",
          "top-right",
          0
        );
        // void 0
      });
  };

  const handlePrev = () => {
    // alert("prev");
    var config = {
      method: "get",
      url: prev.replace("http:", protocol.replace("//", "")),
      headers: {
        Authorization: getToken(),
      },
    };
    // void 0
    axios(config)
      .then(function (response) {
        // void 0
        setData({
          ...data,
          data: response.data.results,
        });
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {
        // void 0
      });
  };

  const handleNext = () => {
    //alert("next")
    var config = {
      method: "get",
      url: next.replace("http:", protocol.replace("//", "")),
      headers: {
        Authorization: getToken(),
      },
    };

    axios(config)
      .then(function (response) {
        // void 0
        setData({
          ...data,
          data: response.data.results,
        });
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {
        // void 0
      });
  };

  return (
    <div>
      <div className="content-body">
        {!loading ? (
          <div className="container-fluid">
            <FilterComponent
              handleNext={handleNext}
              handlePrev={handlePrev}
              next={next}
              prev={prev}
              filterButtonName={"Filter"}
            />
            <FilterModalComponent
              heading={"Filter Customers"}
              searchItemValue={filter.search_text}
              searchItemChange={(e) =>
                setfilter({
                  ...filter,
                  search_text: e.target.value,
                })
              }
              clearFilter={(e) => {
                e.preventDefault();
                window.location.reload();
                localStorage.removeItem("customer_filter");
              }}
              submitFilter={(e) => {
                e.preventDefault();
                getData();
                localStorage.setItem("customer_filter", JSON.stringify(filter));
              }}
            >
              <div className="col-lg-6">
                <div className="form-group">
                  <label className="text-black font-w600">
                    Approved <span className="required"></span>
                  </label>
                  <select
                    value={filter.is_approved}
                    class="form-control form-control-lg  "
                    onChange={(e) =>
                      setfilter({
                        ...filter,
                        is_approved: e.target.value,
                      })
                    }
                  >
                    <option value={""} id={""}>
                      All
                    </option>
                    <option value={"true"} id={"true"}>
                      Yes
                    </option>
                    <option value={"false"} id={"false"}>
                      No
                    </option>
                  </select>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="form-group">
                  <label className="text-black font-w600">
                    Blocked <span className="required"></span>
                  </label>
                  <select
                    value={filter.is_blocked}
                    class="form-control form-control-lg  "
                    onChange={(e) =>
                      setfilter({
                        ...filter,
                        is_blocked: e.target.value,
                      })
                    }
                  >
                    <option value={""} id={""}>
                      All
                    </option>
                    <option value={"true"} id={"true"}>
                      Yes
                    </option>
                    <option value={"false"} id={"false"}>
                      No
                    </option>
                  </select>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="form-group">
                  <label className="text-black font-w600">
                    Customers <span className="required"></span>
                  </label>
                  <select
                    value={filter.is_customer}
                    class="form-control form-control-lg"
                    onChange={(e) =>
                      setfilter({
                        ...filter,
                        is_customer: e.target.value,
                        is_deliveryboy: "",
                        is_branch_admin: "",
                        is_manager: "",
                      })
                    }
                  >
                    <option value={""} id={""}>
                      Not apply
                    </option>
                    <option value={"true"} id={"true"}>
                      Yes
                    </option>
                  </select>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="form-group">
                  <label className="text-black font-w600">
                    Delivery Boy <span className="required"></span>
                  </label>
                  <select
                    value={filter.is_deliveryboy}
                    class="form-control form-control-lg  "
                    onChange={(e) =>
                      setfilter({
                        ...filter,
                        is_customer: "",
                        is_deliveryboy: e.target.value,
                        is_branch_admin: "",
                        is_manager: "",
                      })
                    }
                  >
                    <option value={""} id={""}>
                      Not apply
                    </option>
                    <option value={"true"} id={"true"}>
                      Yes
                    </option>
                  </select>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="form-group">
                  <label className="text-black font-w600">
                    Manager <span className="required"></span>
                  </label>
                  <select
                    value={filter.is_manager}
                    class="form-control form-control-lg  "
                    onChange={(e) =>
                      setfilter({
                        ...filter,
                        is_customer: "",
                        is_deliveryboy: "",
                        is_branch_admin: "",
                        is_manager: e.target.value,
                      })
                    }
                  >
                    <option value={""} id={""}>
                      Not apply
                    </option>
                    <option value={"true"} id={"true"}>
                      Yes
                    </option>
                  </select>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="form-group">
                  <label className="text-black font-w600">
                    Branch Admin <span className="required"></span>
                  </label>
                  <select
                    value={filter.is_branch_admin}
                    class="form-control form-control-lg  "
                    onChange={(e) =>
                      setfilter({
                        ...filter,
                        is_customer: "",
                        is_deliveryboy: "",
                        is_branch_admin: e.target.value,
                        is_manager: "",
                      })
                    }
                  >
                    <option value={""} id={""}>
                      Not apply
                    </option>
                    <option value={"true"} id={"true"}>
                      Yes
                    </option>
                  </select>
                </div>
              </div>
            </FilterModalComponent>

            <div className="row">
              <div className="col-lg-12">
                <div className="table-responsive rounded card-table">
                  <div
                    id="example5_wrapper"
                    class="dataTables_wrapper no-footer"
                  >
                    {data.data.length ? (
                      <table
                        className="table border-no order-table mb-4 table-responsive-lg dataTablesCard"
                        id="example5"
                      >
                        <thead>
                          <tr>
                            <th>CUSTOMER ID</th>
                            <th>NAME</th>
                            <th>EMAIL</th>
                            <th>PHONE</th>
                            <th>JOINED DATE</th>
                            <th>BLOCKED</th>
                            <th />
                          </tr>
                        </thead>
                        <tbody id="customers">
                          {data.data.map((customer) => {
                            const joinedDateStr =
                              customer.created_at ||
                              customer.date_joined ||
                              customer.details?.created_at;
                            return (
                              <tr className="btn-reveal-trigger">
                                <td className="py-2">
                                  <a href={`/customerID/${customer.id}`}>
                                    <h5 className="mb-0 fs--1">
                                      {" "}
                                      FDRCSR{customer.id}
                                    </h5>
                                  </a>
                                </td>
                                <td className="py-3">
                                  <a href={`/customerID/${customer.id}`}>
                                    <div className="media d-flex align-items-center">
                                      <div className="avatar avatar-xl mr-2">
                                        <div className>
                                          <div
                                            style={{
                                              background: random_rgba(),
                                              width: 40,
                                              height: 40,
                                              borderRadius: 20,
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                            }}
                                          >
                                            <h5 className="mb-0 fs--1">
                                              {customer.first_name
                                                .charAt(0)
                                                .toUpperCase()}
                                            </h5>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="media-body">
                                        <h5 className="mb-0 fs--1">
                                          {" "}
                                          {customer.first_name}
                                        </h5>
                                        <span className="py-2">
                                          {customer.is_franchise_admin && (
                                            <i
                                              title={"Franchise Admin"}
                                              className="fa fa-user pr-1"
                                              style={{ color: "#1a0ace" }}
                                            />
                                          )}
                                          {customer.is_franchise_manager && (
                                            <i
                                              title={"Franchise Manager"}
                                              className="fa fa-user pr-1"
                                              style={{ color: "#3695eb" }}
                                            />
                                          )}
                                          {customer.is_franchise_staff && (
                                            <i
                                              title={"Franchise Staff"}
                                              className="fa fa-user pr-1"
                                              style={{ color: "#a59ef7" }}
                                            />
                                          )}
                                          {customer.is_branch_admin && (
                                            <i
                                              title={"Restaurant Admin"}
                                              className="fa fa-user pr-1"
                                              style={{ color: "#db0202" }}
                                            />
                                          )}
                                          {customer.is_manager && (
                                            <i
                                              title={"Restaurant manager"}
                                              className="fa fa-user pr-1"
                                              style={{ color: "#ff7373" }}
                                            />
                                          )}
                                          {customer.is_delivery_boy && (
                                            <i
                                              title={"Delivery boy"}
                                              className="fa fa-user pr-1"
                                              style={{ color: "#ffe900" }}
                                            />
                                          )}
                                        </span>
                                      </div>
                                    </div>
                                  </a>
                                </td>
                                <td className="py-2">
                                  <a href={`/customerID/${customer.id}`}>
                                    {customer.email ? (
                                      <h5 className="mb-0 fs--1">
                                        {customer.email}
                                      </h5>
                                    ) : (
                                      <h5 className="mb-0 fs--1">No Email</h5>
                                    )}
                                  </a>
                                </td>

                                <td className="py-2">
                                  {" "}
                                  <a href={`/customerID/${customer.id}`}>
                                    {customer.details
                                      ? customer.details.mobile
                                      : "No number"}
                                  </a>
                                </td>

                                <td className="py-2">
                                  <a href={`/customerID/${customer.id}`}>
                                    <h5 className="mb-0 fs--1">
                                      {joinedDateStr
                                        ? new Date(joinedDateStr).toLocaleDateString()
                                        : "N/A"}
                                    </h5>
                                  </a>
                                </td>

                                <td className="py-2">
                                  {" "}
                                  <a href={`/customerID/${customer.id}`}>
                                    {customer.details && (
                                      <h5 className="mb-0 fs--1">
                                        {customer.details.is_blocked
                                          ? "YES"
                                          : "NO"}
                                      </h5>
                                    )}
                                  </a>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    ) : (
                      <NoDataComponent data="Users" />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <LoadingComponent />
        )}
      </div>
    </div>
  );
}

function Customers() {
  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header
          name={"Customers"}
          subHeading={"All customers under the franchisee"}
        />
        <NavBar />
        <Body />
        <Footer />
      </div>
    </div>
  );
}

export default Customers;
